/**
 * Returns a compact keyboard shortcut string for display in the UI,
 * formatted for the current OS.
 *
 * Mac:          ⌘⇧U   (Command + Shift + letter, compact Unicode glyphs)
 * Windows/Linux: Ctrl ⇧ U  (Ctrl keyword + Shift glyph + letter)
 *
 * @param letter - The single uppercase letter key (e.g. "U", "E", "S", "M").
 */
export function formatQuickActionShortcut(letter: string): string {
  const isMac = /Mac|iPhone|iPad|iPod/i.test(
    // navigator.platform is deprecated but still widely supported;
    // fall back to userAgent for environments where platform is empty.
    navigator.platform || navigator.userAgent
  );
  const upper = letter.toUpperCase();
  return isMac ? `⌘⇧${upper}` : `Ctrl ⇧ ${upper}`;
}
